import type { ContractStatus } from "Infrastructure/Api/Api";

const keys = {
	documents: ["documents"] as const,
	documentDetail: (documentId: string | null | undefined) =>
		[...keys.documents, "detail", documentId] as const,
	contracts: (
		advisoryCaseId: string | null | undefined,
		contractStatus: ContractStatus[],
	) => ["contracts", advisoryCaseId, contractStatus] as const,
	documentRules: ["documentRules"] as const,
	advisoryCases: (consultantId: string | null | undefined) =>
		["advisoryCases", consultantId] as const,
	advisoryCase: (advisoryCaseId: string | null | undefined) =>
		["advisoryCase", advisoryCaseId] as const,
	advisoryTools: (categories: string[] | null | undefined) =>
		["advisoryTools", categories] as const,
	proposedSolutions: (advisoryCaseId: string | null | undefined) =>
		["proposedSolutions", advisoryCaseId] as const,
	investmentQuestionnaire: (clientId: number | null | undefined) =>
		["investmentQuestionnaire", clientId] as const,
	productCategories: () => ["productCategories"] as const,
	products: (
		categoryCode: string | null | undefined,
		partnerCode: string | null | undefined,
	) => ["products", categoryCode, partnerCode] as const,
	partners: (categoryCode: string | null | undefined) =>
		["partners", categoryCode] as const,
	requiredDocuments: (contractId: string | null | undefined) =>
		["requiredDocuments", contractId] as const,
};

export default keys;
